import React, { FC } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { InputNumber } from "primereact/inputnumber";
import { T } from "services/lang/LanguageService";
import { Chips, ChipsChangeEvent } from "primereact/chips";
import { DialIndicatorEditorProps } from "./DialIndicatorTypes";

const DialIndicatorTicksEditor: FC<DialIndicatorEditorProps> = ({ config, onConfigChange }) => {
  const handleConfigChange = (e: ChipsChangeEvent) =>
    onConfigChange({
      ...config,
      ticks: (e.value ?? [])
        .map((v: string) => {
          const parsed = parseFloat(v);
          return Number.isNaN(parsed) ? null : { value: parsed };
        })
        .filter((tick): tick is { value: number } => tick !== null),
    });

  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-column gap-2">
        <label htmlFor="ticks">{T("word.ticks")}</label>
        <Chips
          id="ticks"
          value={(config.ticks ?? []).map(t => String(t.value))}
          onChange={e => handleConfigChange(e)}
        />
      </div>
      <div className="flex flex-row gap-3">
        <div className="flex flex-column gap-2 w-2">
          <label htmlFor="ticksFontSize">{T("word.ticks-font-size")}</label>
          <div className="p-inputgroup w-full">
            <InputNumber
              id="ticksFontSize"
              value={config.ticksFontSize ?? 15}
              onValueChange={e => onConfigChange({ ...config, ticksFontSize: e.value ?? 0 })}
            />
            <span className="p-inputgroup-addon">px</span>
          </div>
        </div>
        <div className="flex flex-column gap-2">
          <label htmlFor="hideTicks">{T("action.hide-ticks")}</label>
          <InputSwitch
            id="hideTicks"
            checked={config.hideTicks ?? false}
            onChange={e => onConfigChange({ ...config, hideTicks: e.value })}
          />
        </div>
      </div>
    </div>
  );
};

export default DialIndicatorTicksEditor;
